import Vue from "vue"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import { extend } from "vee-validate"
import {
  required,
  email,
  confirmed,
  numeric,
  is_not,
  min_value,
  is,
  regex,
  alpha_num,
  alpha,
} from "vee-validate/dist/rules"
Vue.component("ValidationProvider", ValidationProvider)
Vue.component("ValidationObserver", ValidationObserver)

extend("equal_to", {
  ...is,
  params: ["other"],
  message: (value, { other }) => {
    return `${value} entered no equal to: ${other}`
  },
})

extend("requiredPasswordConfirmation", {
  ...required,
  message: "Re-enter password",
})
extend("required", {
  ...required,
  message: "Enter {_field_}",
})
extend("min_value", {
  ...min_value,
  message: "{_field_} must be minimum {min}",
})
extend("requiredCameras", {
  ...required,
  message: "Select at least one camera",
})
extend("requiredRecipients", {
  ...required,
  message: "Enter at least one recipient's email",
})
extend("requiredDays", {
  ...required,
  message: "Select at least one day",
})
extend("alpha_num", {
  ...required,
  ...alpha_num,
  message: "Must contain at least one number and one uppercase, and at least 8 or more characters",
})
extend("email", {
  ...email,
  message: "Enter a valid email",
})
extend("confirmed", {
  ...confirmed,
  message: "Please enter the same password",
})
extend("numeric", {
  ...numeric,
  message: "{_field_} field may only contain numeric characters",
})
extend("is_not", {
  ...is_not,
  message: "New password should be different from current password",
})
